import { useSFetch } from '../hooks/sfetch';

export type WithOk<T> = T & { ok: boolean };

export const useSfetchMutator = () => {
    const sfetch = useSFetch();
    // Orval's fetch client expects { data, status, headers }. sfetch returns the parsed envelope
    // directly ({ status, value, errors, ok }). We surface that as `data` and return `any` so Orval's
    // per-operation discriminated-union response types accept it — call sites still see the typed
    // signature Orval generates around this function.
    return async (url: string, init?: RequestInit): Promise<any> => {
        const res = await sfetch(url, init);
        return {
            data: res,
            status: res?.status ?? 0,
            headers: new Headers(),
        };
    };
};
